import { action, observable } from "mobx";
import { IActivationJSON } from "../interfaces";
import { PLACE_OF_BIRTH, POB_OTHERS } from "../constants";

export type BusinessScale = "UMI" | "UKE" | "UME" | "UBE";

export class Activation {
  @observable
  businessScale: BusinessScale | null = null;

  @observable
  dob = "";

  @observable
  pob = "";

  @observable
  pobOthers = "";

  @observable
  selfieUrl = "";

  @observable
  businessPhotoUrl = "";

  @action
  updatePartial(json: Partial<IActivationJSON>) {
    if (json.business_scale)
      this.businessScale = json.business_scale as BusinessScale;
    if (json.dob) this.dob = json.dob!!;
    if (json.pob)
      this.pob = PLACE_OF_BIRTH.includes(json.pob.toUpperCase())
        ? json.pob
        : POB_OTHERS;
    if (json.pob)
      this.pobOthers = PLACE_OF_BIRTH.includes(json.pob.toUpperCase())
        ? ""
        : json.pob;
    if (json.selfie_url) this.selfieUrl = json.selfie_url;
    if (json.business_photo_url)
      this.businessPhotoUrl = json.business_photo_url;
  }

  static fromJSON(json: IActivationJSON): Activation {
    const activation = new Activation();

    activation.businessScale = json.business_scale
      ? (json.business_scale as BusinessScale)
      : null;
    activation.dob = json.dob;
    activation.pob = PLACE_OF_BIRTH.includes(json.pob.toUpperCase())
      ? json.pob
      : POB_OTHERS;
    activation.pobOthers = PLACE_OF_BIRTH.includes(json.pob.toUpperCase())
      ? ""
      : json.pob;
    activation.selfieUrl = json.selfie_url;
    activation.businessPhotoUrl = json.business_photo_url;

    return activation;
  }
}
